//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      }
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteRow: function (row) {
      let data = {id: row.locationId}
      // console.log('data', data)
      this.$axios.post('/mtea/store/admin/dealer/pick/location/del', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    }
  }
}
